export const TestIds = {
  bubble: 'ai-bubble',
  avatar: 'ai-bubble-avatar',
  message: 'ai-bubble-message',
  timestamp: 'ai-bubble-timestamp',
  actions: 'ai-bubble-actions',
  copyButton: 'ai-bubble-copy-button',
  positiveFeedbackButton: 'ai-bubble-positive-feedback-button',
  negativeFeedbackButton: 'ai-bubble-negative-feedback-button',
};
